module.exports = __webpack_public_path__ + "img/lock.c9ea9ebc.svg";